import { FacetValue } from "@coveo/headless";
import { useEffect, useState } from "react";
import { FacetMobileProps } from "components/coveo-headless/types/coveo-headless-types";

const FacetMobile = ({ facet, facetGroup, sortItems = true, showCount }: FacetMobileProps) => {
	const [facetState, setState] = useState(facet.state);
	const [anyValueSelected, setAnyValueSelected] = useState(false);
	const [facetArr, setFacetArr] = useState<FacetValue[]>([]);

	useEffect(() => {
		facet.subscribe(() => {
			setState(facet.state);
		});
	}, [facet]);

	useEffect(() => {
		if (sortItems && facet.state.values.length) {
			const arr = [...facet.state.values];
			setFacetArr(
				arr.sort((a, b) => a.value.localeCompare(b.value, undefined, { sensitivity: "base" }))
			);
		}
		const valueSelected = (element: FacetValue) => element.state === "selected";
		setAnyValueSelected(facet.state.values.some(valueSelected));
	}, [sortItems, facet.state.values]);

	if (facet.state.values.length === 0) {
		return <></>;
	}

	return (
		<>
			{(facetArr.length ? facetArr : facet.state.values).map((item) => (
				<li key={`${item.value}-mobile`} className="coveo-headless-mobile-facets">
					<input
						aria-label={item.value}
						className="coveo-headless-mobile-facet-checkShow"
						checked={facet.isValueSelected(item)}
						data-a="true"
						data-a-lbl={item.value}
						data-a-cat="Coveo"
						data-a-act={`Filter | ${facetGroup}`}
						disabled={facetState.isLoading}
						name="facet"
						type="checkbox"
						onChange={() => facet.toggleSelect(item)}
					/>
					<span className="coveo-headless-mobile-facet-caption">
						{item.value}
						{showCount && (
							<span className="coveo-headless-mobile-facet-value-count">
								{`(${anyValueSelected && !facet.isValueSelected(item) ? "+" : ""}${
									item.numberOfResults
								})`}
							</span>
						)}
					</span>
				</li>
			))}
		</>
	);
};

export default FacetMobile;
